import { Language, LayoutType } from '../model/types';
import { LAYOUT_LANGUAGES } from '../model/constants';

export const isLanguageAvailable = (languageCode: Language['code'], layoutType: LayoutType): boolean => {
  const availableLanguages = LAYOUT_LANGUAGES[layoutType];
  return availableLanguages.some((lang) => lang.code === languageCode);
};
